module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "drive-card@2x.52d54936.png" + "?" + Date.now();